import { z } from 'zod';

export const LoyaltyPointsPerCurrencyDTO = z.number().nullish();

export type LoyaltyPointsPerCurrencyDTO = z.infer<typeof LoyaltyPointsPerCurrencyDTO>;
